// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <detail-view
  :endpoint="endpoint + 'sites'"
  name="site"
  parentRoute="sites"
  permissions="sites"
  :values="values"
  ></detail-view>
</template>
<script>
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'
import {ENDPOINT} from '@/shared/constants'
import {listToText} from '@sdgsystems/vue-common/components/utils'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Description',
                value: 'description'
              },
              {
                name: 'Start Date',
                value: 'startDate',
                type: 'date',
                required: true
              }
            ],
            [
              {
                name: 'Address Line 1',
                value: 'addressLine1'
              },
              {
                name: 'Address Line 2',
                value: 'addressLine2'
              },
              {
                name: 'City',
                value: 'city'
              },
              {
                name: 'State',
                value: 'state'
              },
              {
                name: 'Country',
                value: 'country'
              },
              {
                name: 'Postal Code',
                value: 'zipcode'
              },
              {
                name: 'Timezone',
                value: 'timezone.id',
                context: ENDPOINT + 'timezones',
                type: 'select',
                itemText: 'id',
                itemValue: 'id',
                required: true
              }
            ]
          ]
        },
        {
          name: 'Reports',
          items: [
            [
              {
                text: 'Reports',
                value: 'reportSettings',
                type: 'component',
                component: 'site-report-settings'
              }
            ]
          ]
        },
        {
          name: 'Endpoints',
          items: [
            [
              {
                name: 'Endpoints',
                value: ENDPOINT + 'endpoints',
                type: 'itemList',
                allowAdd: true,
                editRoute: 'endpointEdit',
                id: '_id',
                filter: [{
                  name: 'site',
                  value: '_id'
                }],
                headers: [
                  {
                    text: 'Name',
                    value: 'name',
                    sortable: true
                  },
                  {
                    text: 'Description',
                    value: 'description',
                    sortable: true
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  },

  methods: {
    objectToText: function (key, list) {
      var output = []
      for (var i in list) {
        output.push(list[i][key])
      }
      return listToText(output)
    },

    tradeGroupsToText: function (item) {
      return this.objectToText('label', item['tradegroups'])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteEdit.vue